import { ready, onceInitialized } from '../../lib/lifecycle/ready';
import { truncateWords } from '../../lib/utils/truncateWords';

function modulrPostExcerptInit(root) {
  const scope = root || document;
  // Query loop handles truncation separately.
  const excerptBlocks = scope.querySelectorAll('.wp-block-modulr-post-excerpt[data-word-limit]');

  excerptBlocks.forEach((block) => {
    if (!onceInitialized(block, 'post-excerpt')) return;

    const wordLimit = parseInt(block.dataset.wordLimit, 10);

    if (!wordLimit || wordLimit <= 0) {
      return;
    }

    const isInQueryLoop = block.closest('[data-query-params]');
    if (isInQueryLoop) {
      return;
    }

    const pElement = block.querySelector('p');
    if (!pElement) {
      return;
    }

    const currentText = pElement.textContent || pElement.innerText || '';
    if (currentText.trim().length > 0) {
      const truncatedText = truncateWords(currentText, wordLimit);
      pElement.textContent = truncatedText;
    }
  });
}

ready(modulrPostExcerptInit, { scope: 'modulr-post-excerpt' });
